// App version — naye deploy se pehle is number ko badho (e.g. '1.0.0' -> '1.0.1')
export const APP_VERSION = '1.6.0';

// Build ka waqt — ye KHUD build ke waqt set hota hai (package.json ke build script se).
// Ise haath mat lagao. Agar env set na ho (local dev) to 'dev' dikhega.
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || 'dev';
